import * as THREE from "three";
import { GLTF, GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { clone as cloneSkeleton } from "three/examples/jsm/utils/SkeletonUtils.js";

const gltfCache = new Map<string, Promise<GLTF>>();
const loader = new GLTFLoader();
const CAPSY_MODEL_PATHS = [
  "/capsy_ai_drug_developer.glb?v=capsy-ai-front-inner-rotation-20260713",
  "/capsy_ai_drug_developer.glb?v=capsy-frustrate-model-20260713",
  "/capsy_runner.glb?v=capsy-runner-large-headroom-20260713",
];

const loadGltf = (url: string) => {
  const cached = gltfCache.get(url);
  if (cached) return cached;

  const request = new Promise<GLTF>((resolve, reject) => {
    loader.load(url, resolve, undefined, reject);
  });
  gltfCache.set(url, request);
  return request;
};

export const loadCachedGltfClone = async (url: string) => {
  const gltf = await loadGltf(url);
  return {
    scene: cloneSkeleton(gltf.scene) as THREE.Group,
    animations: gltf.animations,
  };
};

export const preloadCapsyModels = () => {
  CAPSY_MODEL_PATHS.forEach((path) => {
    loadGltf(`${process.env.PUBLIC_URL}${path}`).catch(() => {
      gltfCache.delete(`${process.env.PUBLIC_URL}${path}`);
    });
  });
};
